import React from 'react';
import { BottomNavigation, BottomNavigationAction, useMediaQuery, useTheme, Paper } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import ChurchIcon from '@mui/icons-material/Church';
import AnnouncementIcon from '@mui/icons-material/Campaign';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import PersonIcon from '@mui/icons-material/Person';
import FavoriteIcon from '@mui/icons-material/Favorite';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import GroupsIcon from '@mui/icons-material/Groups';

function BottomNav({ user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!isMobile || !user) {
    return null;
  }

  // Bottom nav shows only the most frequently used items (max 5 for better UX)
  const superAdminMenuItems = [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/super-admin/dashboard' },
    { label: 'Churches', icon: <ChurchIcon />, path: '/super-admin/churches' },
    { label: 'Users', icon: <PeopleIcon />, path: '/super-admin/users' },
    { label: 'Profile', icon: <PersonIcon />, path: '/super-admin/profile' },
  ];

  const churchAdminMenuItems = [
    { label: 'Dashboard', icon: <DashboardIcon />, path: '/church-admin/dashboard' },
    { label: 'Members', icon: <PeopleIcon />, path: '/church-admin/members' },
    { label: 'Announcements', icon: <AnnouncementIcon />, path: '/church-admin/announcements' },
    { label: 'Sermons', icon: <VideoLibraryIcon />, path: '/church-admin/sermons' },
    { label: 'Prayer', icon: <FavoriteIcon />, path: '/church-admin/prayer-requests' },
  ];

  const churchUserMenuItems = [
    { label: 'Home', icon: <DashboardIcon />, path: '/church-user/dashboard' },
    { label: 'Updates', icon: <AnnouncementIcon />, path: '/church-user/announcements' },
    { label: 'Give', icon: <VolunteerActivismIcon />, path: '/church-user/give' },
    { label: 'Sermons', icon: <VideoLibraryIcon />, path: '/church-user/sermons' },
    { label: 'Community', icon: <GroupsIcon />, path: '/church-user/community' },
  ];

  let menuItems = [];
  if (user?.role === 'super_admin') {
    menuItems = superAdminMenuItems;
  } else if (user?.role === 'church_admin') {
    menuItems = churchAdminMenuItems;
  } else if (user?.role === 'church_user') {
    menuItems = churchUserMenuItems;
  }

  const currentPath = location.pathname;
  const activeIndex = menuItems.findIndex(item => currentPath === item.path || currentPath.startsWith(item.path + '/'));

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar,
        display: { xs: 'block', sm: 'none' },
      }}
      elevation={3}
    >
      <BottomNavigation
        value={activeIndex >= 0 ? activeIndex : 0}
        onChange={(event, newValue) => {
          navigate(menuItems[newValue].path);
        }}
        showLabels
        sx={{
          backgroundColor: '#FFFFFF',
          '& .MuiBottomNavigationAction-root': {
            color: '#666666',
            '&.Mui-selected': {
              color: '#d4af39',
            },
          },
        }}
      >
        {menuItems.map((item, index) => (
          <BottomNavigationAction
            key={item.path}
            label={item.label}
            icon={item.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}

export default BottomNav;

